import { ColoursObj, Loading } from '@eventr/common-storybook'
import { Stack } from '@mui/material'
import { useEffect, useMemo } from 'react'
import { useGuestStore } from './guest.store'

import { spErrorTags } from '@eventr/common'
import { Paths } from '../../routes'
import { defaultAddSnack } from '../../state/overlayState/overlayContext'
import { logEvent } from '../firebase/firebase'

export const GuestResolverPage = () => {
    const searchParameters = useMemo(
        () => new URLSearchParams(window.location.search),
        []
    )
    useEffect(() => {
        const resolve = async (encoded: string) => {
            try {
                await useGuestStore.getState().resolveGuestData(encoded)
                window.pushPath(Paths.home)
            } catch (e) {
                logEvent('guest_resolve_failed', { code: encoded })
                defaultAddSnack('Failed to find itinerary', 'error')
                spErrorTags('Failed to find itinerary', ['GuestResolver'])
                window.pushPath('/')
            }
        }
        const encoded = searchParameters.get('data')
        if (encoded) {
            resolve(encoded)
        }
    }, [searchParameters])

    return (
        <Stack alignItems={'center'}>
            <Loading
                height={'100px'}
                width={'100px'}
                color={ColoursObj.core.secondary}
                fill={ColoursObj.core.secondary}
            />
        </Stack>
    )
}
